// removed by extract-text-webpack-plugin
module.exports = {"date":"_2zi34A5bj99JJhJ3vu6BNJ","intro":"_39uKOva4JlXv7oe-dOvicJ","photos":"_1ea4fBceqPbNPlAQk0c23X"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroups/TrainingGroups.scss
// module id = 340
// module chunks = 0